module.exports = __webpack_public_path__ + "static/media/devices.52c77f56.svg";